/**
 * Created by rhinov15 on 28/09/2018.
 *
 * Velux joinery entity node
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { Events, eventsManager, Velux } from "@rhinov/savane-js";

declare var cc: any;

export class VeluxNode extends JoineryNode {
    constructor(jOpening: Velux) {
        // Call super class constructor
        super(jOpening);
        // And prepare the node for display
        this.computeModel(jOpening);

        this.hideVeluxAxo = eventsManager.instance.addListener(Events.HIDE_AXO, (event: any) => {
            this.needRedraw = true;
            this.setVisible(!PlanManager.getInstance()._hideAxo);
        });
    }

     // Prepare node for display
    computeModel(joinery: Velux) {
        // Retrieve joinery parameters if not undefined
        if (joinery !== undefined) {
            this._length = joinery.length;
            this._height = joinery.height;
            if (joinery.wall != null) {
                var slope = joinery.wall.getSlope(joinery);
                var height = joinery.wall.height - joinery.wall.slopeHeight;
                var length;

                if (slope === 1) {
                    length = joinery.wall.slopeLength1;
                }
                else {
                    length = joinery.wall.slopeLength2;
                }

                if (length !== 0) {
                    var slopeAngle = Math.atan(height / length);

                    this._height = this._height * Math.cos(slopeAngle);
                }
            }
        }
    }

    // Draw manual rectangles for the node
    drawOverlap(joinery: Velux, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }

        // Clear the node display
        this.clear();

        // x, y, w, h of the element being displayed
        var h = (this._height * 0.1 - 5);
        var w = this._length * 0.1 - 5;
        var y = -h * 0.5;
        var x = -w * 0.5;
        // Color to use for the display
        var color: {border: any, plain:any} = {border: undefined, plain: undefined};
        // Border size
        var borderSize = 5;

        // Select color depending on valid/invalid, selected/unselected
        if (isValid !== undefined) {
            color = this.getOverLapColor(isValid);
        }
        else {
            color = this.getOverLapColor(true);
        }

        if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
            borderSize /= PlanManager.getInstance().getZoomScale();
        }
        this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, new cc.Color(66, 80, 94, alpha));
        this.drawRect(new cc.p(x + w / 2 - w * 0.1, y + h - h * 0.1), new cc.p(x + w / 2 + w * 0.1, y + h), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
    }

    // Update node model, prepare for next frame display
    updateModel(joinery: Velux, isValid: boolean) {
        // Empty current node display
        this.removeAllChildren();
        // Add prepare the content to display
        this.computeModel(joinery);
        // Call Joinery node update model method
        super.updateModel(joinery, isValid);
        // Draw node additionnal rects
        this.drawOverlap(joinery, isValid);
    }

    removeListeners() {
        super.removeListeners();
        eventsManager.instance.removeListener(this.hideVeluxAxo);
    }

    onExit() {
        super.onExit();
        this.removeListeners();
    }
}
